module.exports = __webpack_public_path__ + "img/empty.8a8346d3.png";